import { ApiPropertyOptional } from '@nestjs/swagger'
import { IsOptional, IsInt, Min } from 'class-validator'
import { Type } from 'class-transformer'

export class UpdateActivityLessonLinkDto {
  @ApiPropertyOptional({
    description: "Ordre de l'activité dans la leçon",
    minimum: 0,
  })
  @IsOptional()
  @Type(() => Number)
  @IsInt()
  @Min(0)
  orderInLesson?: number
}
